import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { NavigationSliceState } from "./types/redux";

// IMPORTANT: The store key for this slice is navigationSlice. You should use this when accessing state related to this slice.
// IMPORTANT: For example to access the activeLink from a component you would use useSelector(state => state.navigationSlice.activeLink)

const initialState: NavigationSliceState = {
  currentPage: 'Dashboard',
  selectedTab: '',
  activeLink: 'Dashboard', // Initially set to 'Dashboard' as the default active navigation link
};

const navigationSlice = createSlice({
  name: "navigationSlice",
  initialState,
  reducers: {
    // Reducer to set the active navigation link
    // Takes a string payload representing the new active link
    // Used by Sidebar to set the active link when a navigation item is clicked or the URL changes
    setActiveLink: (state, action: PayloadAction<string>) => {
      state.activeLink = action.payload;
    },
  },
});

// Export actions for use in components
export const { setActiveLink } = navigationSlice.actions;

// Export the reducer to be used in the store as default export
export default navigationSlice.reducer;
